import _ from 'underscore';
import Backbone from 'backbone';
import Mn from 'backbone.marionette';
import Coremetrics from '@component/common/src/util/Coremetrics';
import template from '../templates/partials/content-thumbnail-title.hbs';
import Util from '../util/Util';

module.exports = Mn.ItemView.extend({
  template,
  events: {
    'click .contentTitle': 'onContentTitleClick',
  },
  initialize() {
    if (!_.isUndefined(this.model)) {
      this.model = new Backbone.Model(this.model.get('content'));
    }
    this.pageName = Util.getCMPageForContent(this.options.config.zone);
  },
  onContentTitleClick(e) {
    Coremetrics.createLinkClickTag({
      href: `${e.target.href}?cm_sp=${this.pageName}-_-modified_pros-_-hero_image_title`,
    });
  },
});
